
export interface NavigationItem {
  name: string;
  href: string;
}

export const navigationItems: NavigationItem[] = [
  { name: "Home", href: "/" },
  { name: "B59 Project", href: "https://projectb59.github.io/buckazoids-site/index.html" },
  { name: "About", href: "/about" },
  { name: "White Paper", href: "https://github.com/Buckazoidscto/Buckazoids-white-paper-CTO-/wiki/Buckazoids-white-paper-English(CTO)" },
  { name: "News", href: "/news" },
  { name: "Buy Buckazoids", href: "/buy" },
  { name: "Community", href: "/community" },
  { name: "Contact Us", href: "/contact-us" },
];
